import { useQuery } from "@tanstack/react-query";
import { getQueryFn } from "@/api/utils";
import { ApiPath } from "@/api/path";
import { useDateRange } from "@/dateRanges/DateRangeContext";


export type OnPeriod = {
  on: string
  off: string
}

export type AssetsOnTimes = {
  assetId: string | number,
  assetName: string,
  onPeriods: OnPeriod[]
}

export type AnalyzedAssetsOnPeriods = {
  isPending: boolean,
  assets: {
    assetId: string | number,
    assetName: string,
    onPeriods: OnPeriod[],
  }[]
}

const useOnPeriods = (
  installationIds: number[], shouldFetch: boolean = true
): AnalyzedAssetsOnPeriods => {

  const {
    dateRange,
    refreshInterval,
    windowSize,
  } = useDateRange()

  const onTimesResult = useQuery({
    queryKey: ["installation-on-periods", installationIds, dateRange, shouldFetch],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!installationIds && shouldFetch,
    refetchInterval: refreshInterval.value,
    queryFn: getQueryFn<AssetsOnTimes[]>({
      dateRange,
      windowSize,
      installation_id: installationIds
    }, ApiPath.INSTALLATION_REFRIGERANT_ON_PERIODS)
  });

  return {
    isPending: onTimesResult.isPending,
    assets: onTimesResult.isPending || !onTimesResult.data ? [] : installationIds.map(id => {

      const matchingAsset = onTimesResult.data.find((item) => item.assetId === id);
      if (!matchingAsset) {
        throw Error("failed to find match between on times response and requested assets!")
      }

      return {
        assetId: id,
        assetName: matchingAsset.assetName,
        onPeriods: matchingAsset.onPeriods,
      }
    })

  }
}

export default useOnPeriods;
